type SurveyLabelSource = {
  name: string;
  discoverLabel?: string | null;
};

export const getSurveyLabel = (survey: SurveyLabelSource): string =>
  survey.discoverLabel?.trim() || survey.name;
